import type { Point } from "./types";

/**
 * Angle in degrees at `b` formed by points a-b-c (law of cosines).
 * Falls back to 180° when the segment length is zero (degenerate pose).
 */
export function angleDegrees(a: Point, b: Point, c: Point): number {
  const ab = Math.hypot(a.x - b.x, a.y - b.y);
  const bc = Math.hypot(b.x - c.x, b.y - c.y);
  const ac = Math.hypot(a.x - c.x, a.y - c.y);

  if (ab === 0 || bc === 0) {
    return 180;
  }

  const cos = (ab * ab + bc * bc - ac * ac) / (2 * ab * bc);
  const clamped = Math.min(1, Math.max(-1, cos));
  return (Math.acos(clamped) * 180) / Math.PI;
}

/**
 * Elbow bend for a side of the body. A fully straight arm is 180°;
 * the deeper the pushup, the smaller the angle.
 */
export function elbowAngle(shoulder: Point, elbow: Point, wrist: Point): number {
  return angleDegrees(shoulder, elbow, wrist);
}
